import React from 'react';

const TopBannerSection = ({ h1header }) => {
  return (
    <div className="dF alignItemsCenter">
      <div className="marginL10">
        <h1 className="font24 quicksand fb append marginB10">{h1header}</h1>
        <p className="fb">ALL AIRPORTS</p>
      </div>
    </div>
  );
};
export default TopBannerSection;
